import React from 'react';
import './PlaybackError.css';

const PlaybackError = ({ status, onRetry }) => status === 'error' ? (
  <p className="playback-error" role="alert">
    Не удалось подключиться к радио.{' '}
    <button type="button" onClick={onRetry}>Повторить</button>
  </p>
) : null;

export default PlaybackError;
